export default function isValidRG(rg) {
    var numbers = rg.replace(/[^0-9]/g,'');
    return parseInt(numbers) > 0;
}
